module.exports = __webpack_public_path__ + "img/797-cc47c5.png";